export const operatorOptions = {
  number: [
    { key: "greater-equal", text: ">=" },
    { key: "lesser-equal", text: "<=" },
    { key: "equal", text: "=" },
  ],
  common: [
    { key: "in", text: "in" },
    { key: "equal", text: "=" },
  ],
};
